import { useCallback, useContext, useSyncExternalStore } from 'react';
import { getWorkerKey } from '@deephaven/jsapi-utils';
import WorkerVariablesContext from "./WorkerVariablesContext.js";
/**
 * Subscribe to the live list of variables on the worker identified by
 * `descriptor`. Returns `null` while the worker connection is being resolved
 * or when no {@link WorkerVariablesContext} provider is mounted; returns the
 * cumulative list (with field-update deltas applied) once the first update
 * arrives.
 *
 * Subscriptions are ref-counted by worker key so multiple consumers targeting
 * the same worker share a single underlying `subscribeToFieldUpdates` call.
 */
export function useWorkerVariables(descriptor) {
  var store = useContext(WorkerVariablesContext);
  var key = getWorkerKey(descriptor);
  var subscribe = useCallback(listener => {
    if (store == null) return () => undefined;
    return store.subscribe(key, listener);
  }, [store, key]);
  var getSnapshot = useCallback(() => store == null ? null : store.snapshot(key), [store, key]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
export default useWorkerVariables;
//# sourceMappingURL=useWorkerVariables.js.map